<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <rect x="4" y="5" width="16" height="14" rx="2" stroke="currentColor" stroke-width="1.75" />
  <path d="M8 9H16M8 12H16M8 15H13" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" />
</svg>
